import React, { useState, useEffect, useContext } from 'react';
import { FaUserCircle, FaMusic, FaEye, FaEyeSlash } from 'react-icons/fa';
import Header from "../components/Header";
import { Link, useNavigate } from 'react-router-dom'
import { AuthContext } from "../context/AuthContext";
import { Button } from "../components/custom_ui/button.tsx";
import { useAlert } from '../context/AlertContext';

const LoginPage = () => {
  const [showPassword, setShowPassword] = useState(false);
  const authContext = useContext(AuthContext);
  const { authLoading } = useContext(AuthContext);  // Correctly access getApplicationData from DataContext
  const [formData, setFormData] = useState({});
  const navigate = useNavigate();
  const { showAlert } = useAlert();

  const handleFieldChange = (name, value) => {
    setFormData(prev => ({ ...prev, [name]: value }));

    console.log("Form Data:", formData);
  };


  const handleLogin = (e) => {
    e.preventDefault();
    const { email, password } = formData;
    let errors = [];
    if (!email || !password) {
      showAlert("All Fields are Required.", "danger");
      return;
    }

    if (!email.trim()) errors.push({ "type": "error", "message": "Email is required." });
    else if (!/\S+@\S+\.\S+/.test(email)) errors.push({ "type": "error", "message": "Email is invalid." });

    if (!password.trim()) errors.push({ "type": "error", "message": "Password is required." });
    else if (password.trim().length < 6) errors.push({ "type": "error", "message": "Password must be at least 6 characters." });

    if (errors.length > 0) {
      console.log("Errors ", errors);
      showAlert(errors[0].message, "danger");
      return;
    }
    authContext.login(email, password);
  }

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="flex items-center justify-center p-4">
        <div className="bg-[#1D1D30] p-8 rounded-xl shadow-lg w-full max-w-md">

          <div className="flex flex-col items-center mb-6">
            <FaUserCircle className="text-7xl text-gold" />
            <h1 className="text-3xl font-bold text-white mt-4">Artist Portal</h1>
            <p className="text-gray-400">Track your music performance</p>
            <div className="flex items-center space-x-2 mt-2">
              <FaMusic className="text-gold/50" />
              <span className="font-semibold text-white">Music Analytics</span>
            </div>
          </div>

          <form>
            <div className="mb-4">
              <label className="block text-gray-400 text-sm mb-2" htmlFor="email">
                Email
              </label>
              <input
                className="w-full bg-[#2A2A40] border border-gray-600 text-white rounded-md py-2 px-3 focus:outline-none focus:border-gold"
                id="email"
                type="email"
                value={formData.email || ''}
                onChange={(e) => handleFieldChange('email', e.target.value)}
                placeholder="Enter your Email"
              />
            </div>

            <div className="mb-6">
              <label className="block text-gray-400 text-sm mb-2" htmlFor="password">
                Password
              </label>
              <div className="relative">
                <input
                  className="w-full bg-[#2A2A40] border border-gray-600 text-white rounded-md py-2 px-3 focus:outline-none focus:border-gold"
                  id="password"
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Enter your password"
                  value={formData.password || ''}
                  onChange={(e) => handleFieldChange('password', e.target.value)}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400"
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
            </div>

            <Button
              className="w-full  text-white font-bold py-3 px-4 rounded-md"
              type="submit"
              onClick={handleLogin}
              disabled={authLoading}
            >
              {authLoading ? <div className="spinner"></div> : "Sign In"}
            </Button>
          </form>

          {/* <div className="mt-8 text-center">
            <p className="text-gray-500 text-xs">Don't have an account? <a href="/artist_register" className="text-purple-400 hover:text-purple-300">Sign Up</a></p>

          </div> */}
        </div>
      </div>
    </div>
  );
};

export default LoginPage;